<template>

  <div>
    <a v-if="!confirm" href="#" class="hit-html-a" v-on:click.prevent="check_confirm()"> <i class="hit-glyphicon hit-glyphicon-bin" v-if="icon"></i> {{ $t('message.delete') }}</a>

    <span v-if="confirm">
      <slot />

      <i class="hit-glyphicon hit-glyphicon-bin" style="display: inline-block; margin: 0 10px;"></i>
      <a href="#" class="hit-html-a" v-on:click.prevent="function(){ check_confirm(); callback() }" style="display: inline-block; margin-right: 5px;">{{ $t('message.yes') }}</a>
      <a href="#" class="hit-html-a" v-on:click.prevent="check_confirm()">{{ $t('message.no') }}</a>
    </span>

  </div>

</template>

<script>

export default{
  name: 'hit_delete',
  data: function () {
    return {
      confirm: false
    }
  },
  methods: {
    check_confirm: function () {
      this.confirm = !this.confirm
    }
  },
  props: {callback: Function, icon: Boolean}
}

</script>
